<template>
  <v-menu
    bottom
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="arrivalPlaces.length === 0 ? null : on"
      >
        <v-icon :color="updateLabelColor()">
          {{ labelValue }}
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <div
        v-for="(arrivalPlace, i) in arrivalPlaces"
        :key="i"
      >
        <v-list-tile
          v-if="arrivalPlace.index != index"
          color="grey darken-2"
          @click="apply(arrivalPlace)"
        >
          <ArrivalPlaceNumber :value="arrivalPlace.index" />
        </v-list-tile>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import ArrivalPlaceNumber from "./ArrivalPlaceNumber.vue";
import { updateShippingArrivalPlace } from "../../../../backend/releaseOrdersApi.js";
export default {
  components: {
    ArrivalPlaceNumber,
  },
  props: ["item"],
  computed: {
    arrivalPlaces() {
      const places = this.$store.getters["releaseOrders/arrivalPlaces"];
      places.forEach((place, index) => {
        place.index = index;
      });

      if (this.index === -1) {
        return places;
      }

      return places;
    },
    labelValue() {
      return this.updateIcon(this.index);
    },
    index() {
      const places = this.$store.getters["releaseOrders/arrivalPlaces"];
      const currentPlace = places.find((i) => {
        return i.id === this.item.arrivalPlaceId;
      });
      return currentPlace ? places.indexOf(currentPlace) : -1;
    },
    shippings() {
      return this.$store.getters["releaseOrders/shippings"];
    },
    releaseOrderId() {
      return this.$store.getters["releaseOrders/releaseOrder"].id;
    },
  },
  methods: {
    updateIcon(value) {
      switch (value) {
        case -1:
          return "exposure_zero";
        case 0:
          return "looks_one";
        case 1:
          return "looks_two";
        case 2:
          return "looks_3";
        case 3:
          return "looks_4";
      }
    },
    updateLabelColor() {
      switch (this.index) {
        case -1:
          return "red lighten-2";
        case 0:
          return "deep-purple lighten-2";
        case 1:
          return "indigo lighten-2";
        case 2:
          return "blue lighten-2";
        case 3:
          return "cyan lighten-2";
      }
    },
    async apply(arrivalPlace) {
      const item = this.shippings.find((s) => {
        return s.id === this.item.id;
      });
      item.arrivalPlaceId = arrivalPlace.id;
      await updateShippingArrivalPlace(
        this.releaseOrderId,
        item.shippingId,
        arrivalPlace.id,
      );
      await this.$store.dispatch(
        "releaseOrders/getShippings",
        this.releaseOrderId,
      );
      this.showInfo("Место прибытия изменено");
    },
  },
};
</script>